export default (setMissions: Function) => (missionId: string, value: boolean) => {
  return setMissions((ps: any) => ps.map((item: any) => ({
    ...item,
    pinned: item.missionId === missionId ? value : item.pinned,
  })));
}